import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

export type ClienteEG = SupabaseClient<Database>

/**
 * Cliente de Supabase para el navegador. Solo usa la llave publicable: la seguridad la dan las
 * políticas RLS. La llave secreta y la service_role nunca llegan a una app (solo a Edge Functions).
 * Devuelve null si falta la configuración, para que la interfaz muestre un aviso en lugar de romperse.
 * Los tipos salen de la base: `python scripts/supabase-sql.py tipos packages/compartido/src/database.types.ts`.
 */
export function crearClienteSupabase(url: string | undefined, llavePublicable: string | undefined): ClienteEG | null {
  if (!url || !llavePublicable) return null
  return createClient<Database>(url, llavePublicable, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  })
}
